
/**
 * 계정 상태
 */
export type UpdateUser200Status = typeof UpdateUser200Status[keyof typeof UpdateUser200Status];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UpdateUser200Status = {
  ACTIVE: 'ACTIVE',
  INACTIVE: 'INACTIVE',
  SUSPENDED: 'SUSPENDED',
  DELETED: 'DELETED',
} as const;
